
const mutations = {
    setAccountDetail(state, { email, nick, avatar, name, surname }) {
        state.accountDetail = { email, nick, avatar, name, surname };
        state.authenticated = true;
    }
};

export default mutations;